import { render, staticRenderFns } from "./MatchGSRP.vue?vue&type=template&id=3d9f8fd9&"
import script from "./MatchGSRP.vue?vue&type=script&lang=ts&"
export * from "./MatchGSRP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports